import Icon from '../assets/next (3).svg';
import { InlineSvg } from './InlineSvg';

import { IconProps } from './types';

export function ArrowRightIcon({ className = '' }: IconProps) {
    return <InlineSvg src={Icon} className={className} style={{ '--svg-color-1': 'var(--color-light-gray)' }} />;
}
